import React, { Component } from 'react';
import { Checkbox, ControlLabel, FormGroup, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { USER_SETUP } from 'actions/const';

class EVScannerUser extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
		};
	}

	componentWillMount() {
		let { selectedData } = this.props;

		let { setValue } = this.props.actions;

		if (selectedData.isNew()) {
		} else {
			setValue(
				USER_SETUP,
				'isHideFinanceData',
				typeof selectedData.get('isHideFinanceData') === 'boolean'
					? selectedData.get('isHideFinanceData')
					: true
			);
			setValue(
				USER_SETUP,
				'isHideClaimedData',
				typeof selectedData.get('isHideClaimedData') === 'boolean'
					? selectedData.get('isHideClaimedData')
					: true
			);

			const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

			this.setState({ isLoading: true });

			var usersQuery = new Parse.Query(Parse.User);

			usersQuery.equalTo('userType', 'MERCHANT');
			usersQuery.containedIn('objectId', selectedData.get('evScannerUserConfig'));

			usersQuery
				.find()
				.then((data) => {
					const label = (obj) => {
						return !isUndefined(obj) ? obj : '';
					};

					setValue(
						USER_SETUP,
						'evScannerUserList',
						data.map(
							(item) =>
								(item = {
									label:
										label(item.get('memberId')) + ' ' + label(item.get('name')),
									value: item.id,
								})
						)
					);
					this.setState({ isLoading: false });
				})
				.catch((err) => {
					this.setState({ isLoading: true });
					console.error('Get evScannerUserList error: ', err);
				});
		}
	}

	renderTr() {
		let { evScannerUserList } = this.props.usersetup;

		let { setValue } = this.props.actions;

		return evScannerUserList.map(({ label, value }, index) => {
			return (
				<tr key={value}>
					<td>
						{label}
						<i
							className="fa fa-times-circle fa-lg"
							style={{ float: 'right', marginTop: '2px', cursor: 'pointer' }}
							onClick={() => {
								evScannerUserList.splice(index, 1);
								setValue(USER_SETUP, 'evScannerUserList', evScannerUserList);
							}}
						></i>
					</td>
				</tr>
			);
		});
	}

	render() {
		let { isLoading } = this.state;

		let { selectedData, loadOptions } = this.props;

		let { evScannerUserList, isHideFinanceData, isHideClaimedData } = this.props.usersetup;

		let { setValue } = this.props.actions;

		if (isLoading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<i className="fa fa-spinner fa-spin fa-3x fa-lg"></i>
				</div>
			);
		} else {
			return (
				<div>
					<FormGroup>
						<Checkbox
							inline
							checked={isHideFinanceData}
							onChange={(e) => {
								setValue(USER_SETUP, 'isHideFinanceData', e.target.checked);
							}}
						>
							Hide finance data
						</Checkbox>
						<Checkbox
							inline
							checked={isHideClaimedData}
							onChange={(e) => {
								setValue(USER_SETUP, 'isHideClaimedData', e.target.checked);
							}}
						>
							Hide claimed data
						</Checkbox>
					</FormGroup>
					<FormGroup>
						<ControlLabel>MERCHANT/EV SCANNER USER</ControlLabel>
						<Select.Async
							autoload={false}
							loadOptions={(input, cb) =>
								loadOptions(input, cb, Parse.User, 'name', selectedData)
							}
							onChange={(val) => {
								var index = (id) =>
									evScannerUserList.map(({ label, value }) => value).indexOf(id);
								// console.log('index', index(val.value));
								if (index(val.value) === -1) {
									evScannerUserList.push(val);
									setValue(USER_SETUP, 'evScannerUserList', evScannerUserList);
								}
							}}
						/>
						<br />
						<Table bordered responsive>
							<tbody>
								<tr>
									<td style={{ textAlign: 'center' }}>
										MERCHANT/EV SCANNER USER
									</td>
								</tr>
								{this.renderTr()}
							</tbody>
						</Table>
					</FormGroup>
				</div>
			);
		}
	}

	componentWillUnmount() {
		let { setValue } = this.props.actions;

		setValue(USER_SETUP, 'isHideFinanceData', true);
		setValue(USER_SETUP, 'isHideClaimedData', true);
		setValue(USER_SETUP, 'evScannerUserList', []);
	}
}

function mapStateToProps(state) {
	var { usersetup } = state;
	const props = {
		usersetup,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(EVScannerUser);



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/EVScannerUser.js